import { h as __h } from "preact";
import { relayMaintenanceModeResponse } from "~/backend/validate.js";
/** @import { relayResponse } from "~/backend/validate.js"; */
import { ApiError, authedApiRequest, response } from "~/lib/api.js";
import { alert } from "~/util/alert.js";
import html from "~/util/html.js";
import Query from "~/util/query.js";
import { confirmModal } from "~/component/ConfirmModal.js";

/**
 * @param {{ orgId: string; enabled: boolean }} props
 * @param {relayResponse} relay
 */
export const setMaintenanceMode = async ({
  orgId,
  enabled
}, relay) => {
  if (enabled) {
    const res = await confirmModal({
      title: "Enable maintenance mode?",
      action: "Enable",
      kind: "primary",
      body: __h("p", {}, "'", relay.name, "' will stop accepting new connections.")
    });
    if (!res) return;
  }
  try {
    const {
      data
    } = await authedApiRequest("PUT", `/v2/orgs/${orgId}/relays/${relay.id}/maintenance-mode`, {
      json: {
        is_enabled: enabled
      },
      schema: response(relayMaintenanceModeResponse)
    });
    Query.invalidate([`/v2/orgs/${orgId}/relays`], [`/v2/orgs/${orgId}/relays/${relay.id}`]);
    alert(`Maintenance mode is now ${data.is_maintenance_mode_enabled ? "enabled" : "disabled"}.`, {
      type: "success"
    });
    return true;
  } catch (err) {
    alert(ApiError.from(err).message, {
      type: "error"
    });
    return;
  }
};